/* TODO: this should be incorporated
(together with executeCallbackFunction)
into authSuccessSlice as part
of FE cleaning initiative (https://vulcan.stepstone.com/browse/KRK-859)
*/
// to listen add
/*
document.addEventListener("RLA_EVENTS_CANDIDATE_LOGIN_SUCCESS", (e) => console.log('login success event triggered'));
*/
export const dispatchLoginSuccessEvent = () => {
    if (typeof document !== 'undefined' && CustomEvent) {
        const loginSuccessEvent = new CustomEvent('RLA_EVENTS_CANDIDATE_LOGIN_SUCCESS');
        document.dispatchEvent(loginSuccessEvent);
    }
};
//# sourceMappingURL=dispatchLoginSuccessEvent.js.map